import { formatMoney } from '../../utils/format';

export const suggestedMeterWaiver = (savedReading, correctedReading, rate, debtLimit) =>
  Number(Math.min(Math.max(0, Number(savedReading) - Number(correctedReading)) * Number(rate || 0), Number(debtLimit || 0)).toFixed(2));

export default function MeterCorrectionWaiver({ savedReading, correctedReading, rate, debtLimit, debt, value, onChange, disabled }) {
  const suggested = suggestedMeterWaiver(savedReading, correctedReading, rate, debtLimit);
  const amount = value === '' ? suggested : Number(value);
  return (
    <div className="mt-3 space-y-2 border-t border-slate-200 pt-3 text-xs text-slate-700">
      <label className="block font-semibold">
        Water Debt Waiver (KSh)
        <input type="number" min="0" max={debtLimit} step="0.01" value={value === '' ? suggested : value}
          onChange={(event) => onChange(event.target.value)} disabled={disabled}
          className="mt-1 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm disabled:bg-slate-100" />
      </label>
      <p>Suggested waiver: {formatMoney(suggested)}</p>
      <p>Unpaid bill linked to this reading: {formatMoney(debtLimit)}</p>
      <p>Water debt: {formatMoney(debt)} → {formatMoney(Math.max(0, debt - (Number.isFinite(amount) ? amount : 0)))}</p>
    </div>
  );
}
